/**
 * Header predictive search: overlay and body scroll lock when dropdown is open.
 */
(function () {
  function init() {
    const predictiveSearchContent = document.querySelector('.predictive-search__content');
    if (!predictiveSearchContent) return;

    const observer = new MutationObserver(function () {
      const hasContent = predictiveSearchContent.innerHTML.trim() !== '';
      if (hasContent) {
        document.body.classList.add('predictive-search-open');
      } else {
        document.body.classList.remove('predictive-search-open');
      }
    });

    observer.observe(predictiveSearchContent, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('click', function (e) {
      const predictiveSearch = document.querySelector('.header__search-wrapper .predictive-search');
      const searchInput = document.querySelector('.header__search-input');
      if (predictiveSearch && !predictiveSearch.contains(e.target) && e.target !== searchInput) {
        if (searchInput && document.body.classList.contains('predictive-search-open')) {
          predictiveSearchContent.innerHTML = '';
          document.body.classList.remove('predictive-search-open');
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
